import { InjectionToken } from '@angular/core';

export const BASE_SERVICE = new InjectionToken('BASE_SERVICE');
